import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getTextDefaults } from './translations/sectionNavTranslations';

const buttonStyle = {
	flexGrow: 1,
	height: 65,
	padding: 2,
	border: 'none',
	// borderRadius: 0
};
export const NavButton = ({ onClick, children, beforeIcon, afterIcon, disabled, color, sx, customNavButtonColors = {} }) => {
	return (
		<Button
			sx={{
				...buttonStyle,
				...sx,
				...(
					(customNavButtonColors.color || customNavButtonColors.background)
					&& {
						color: customNavButtonColors.color,
						backgroundColor: customNavButtonColors.background,
						'&:hover': {
							backgroundColor: customNavButtonColors.background,
							opacity: 0.8,
						},
					}),
			}}
			variant="contained"
			onClick={onClick}
			disabled={disabled}
			color={color} >
			{beforeIcon}
			{beforeIcon && <span style={{ flexGrow: 1 }} />}
			{children}
			{afterIcon && <span style={{ flexGrow: 1 }} />}
			{afterIcon}
		</Button>
	);
};
const SectionNav = ({
	next,
	previous,
	navigation = {},
	customNavigationColors = {},
	previousIcon = '',
	afterIcon = '',
	hasPrevious = true,
	hasNext = true,
	canContinue = true,
	selectedLanguage = 'EN',
	disabled = false,
}) => {
	const textDefaults = getTextDefaults(selectedLanguage) || {};

	const {
		nextLabel = textDefaults.next,
		previousLabel = textDefaults.previous,
		submitLabel = textDefaults.submit,
	} = navigation;

	return (
		<Box style={{
			position: 'absolute',
			display: 'flex',
			justifyContent: 'center',
			bottom: 16,
			left: 16,
			right: 16,
		}}>
			<ButtonGroup style={{
				maxWidth: 650,
				width: '100%',
			}}>
				{hasPrevious && <NavButton onClick={previous} beforeIcon={previousIcon || <ArrowBackIcon />} customNavButtonColors={{ color: customNavigationColors.text, background: customNavigationColors.previous }} >
					{previousLabel}
				</NavButton>}

				<NavButton
					afterIcon={afterIcon || <ArrowForwardIcon />}
					disabled={!canContinue || (!hasNext && disabled)}
					onClick={next}
					color='secondary'
					customNavButtonColors={{ color: customNavigationColors.text, background: customNavigationColors.next }}
				>{hasNext ? nextLabel : submitLabel}</NavButton>
			</ButtonGroup>
		</Box>
	);
};

export default SectionNav;
